import React from 'react';
import { Paper, Table , TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@material-ui/core';

// const LEGEND_MAP = {
//     '固定可動': 1,
//     '多点固定': 2,
//     '分散構造': 3,
//     '免震構造': 4,
// }
function ChartLegend(props) {
    const { values, COLORS } = props;
    const { chartParam, chartData } = values;
    const { legend } = chartData;
    const changeActiveIndex = (event) => {
        props.setActiveIndex(parseInt(event.currentTarget.getAttribute("data-key")));
    }
    const resetActiveIndex = () => {
        props.setActiveIndex(-1);
    }
    const changeShishoKozoKubun = (event) => {
        props.setChartVisibleStyle({display: 'none'});
        props.setShishoKozoKubun(event.currentTarget.getAttribute("value"));
        window.scrollTo(0, 0);
    }
    const linkUrl = (event) => {
        window.open(event.currentTarget.getAttribute("value"));
    }
    return (
        <React.Fragment>
            <Paper align="right" className="chart-legend-annotation">(2016年以降の弊社設計実績)</Paper>
            <TableContainer component={Paper} className="chart-legend-table">
                <Table size="small" aria-label="legend">
                    <TableHead className="chart-legend-table-header">
                        <TableRow>
                            <TableCell className="chart-legend-table-header-cell">区分</TableCell>
                            <TableCell align="right" className="chart-legend-table-header-cell">件数</TableCell>
                            <TableCell align="right" className="chart-legend-table-header-cell">割合</TableCell>
                            <TableCell align="right" className="chart-legend-table-header-cell"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {legend.map((entry, index) => (
                        <TableRow key={index} hover={true} className="chart-legend-table-body-row" data-key={index} onMouseOver={changeActiveIndex} onMouseLeave={resetActiveIndex} onClick={changeActiveIndex}>
                            {chartParam.shishoKozoKubun === '' ?
                            <TableCell component="th" scope="row" className="chart-legend-table-body-cell"><i className="chart-legend-square" style={{color: COLORS[index > COLORS.length-1 ? index - COLORS.length : index]}}></i> {entry.name}</TableCell> :
                            <TableCell component="th" scope="row" className="chart-legend-table-body-cell"><i className="chart-legend-square" style={{color: COLORS[index > COLORS.length-1 ? index - COLORS.length : index]}}></i> <a href="javascript:void(0)" value={entry.url} onClick={linkUrl}>{entry.name}</a></TableCell>
                            }
                        <TableCell align="right" className="chart-legend-table-body-cell">{`${entry.value.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}件`}</TableCell>
                            <TableCell align="right" className="chart-legend-table-body-cell">{`${(entry.percent * 100).toFixed(2)}%`}</TableCell>
                            <TableCell align="center" className="chart-legend-table-body-cell">
                                {chartParam.shishoKozoKubun === '' ? 
                                    // <Button size="small" variant="contained" color="primary" className="chart-legend-table-body-button" value={LEGEND_MAP[entry.name]} onClick={changeShishoKozoKubun}>
                                    <Button size="small" variant="contained" color="primary" className="chart-legend-table-body-button" value={entry.code} onClick={changeShishoKozoKubun}>
                                    内 訳
                                    </Button> : 
                                    <div></div>
                                }
                            </TableCell>
                        </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Paper elevation={0} className="chart-legend-description">
                {chartParam.shishoKozoKubun === '' ? 
                    <div>内訳ボタンを<span className="chart-legend-entertype"></span>すると、採用製品の内訳一覧を表示します</div> :
                    <div></div>
                }
            </Paper>
        </React.Fragment>
    )
}

export default ChartLegend;
